<!-- 客户详情 -->
<template>
    <div>
        <veui-drawer
            overlay-class="customer-detail"
            placement="right"
            :footless="true"
            :outside-closable="true"
            :open="open"
            :modal="true"
            @cancel="close"
        >
            <!-- 线索消耗详情 -->
            <div class="info">
                <div class="section-title">线索消耗详情</div>
                <div class="columns">
                    <div class="column">
                        <div class="item">
                            <div class="title">律师名</div>
                            <div class="content">
                                {{ formData.name || "-" }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">当月已配置认领数量</div>
                            <div class="content">
                                {{ addClueFormData.add_clue_quota || "-" }}
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="item">
                            <div class="title">会员类型</div>
                            <div class="content">
                                {{ codeTypeMap[formData.codeType] || "-" }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">本月已消耗线索数量</div>
                            <div class="content">
                                {{
                                    addClueFormData.consumed_add_clue_quota ||
                                        "-"
                                }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 线索加购记录 -->
            <div class="record">
                <div class="section-title">律师线索加购记录</div>
                <veui-table :data="addClueTableData" role="columnheader">
                    <veui-table-column
                        field="index" title="序号"
                        width="100"
                    >
                        <template #default="{index}">
                            {{ index + 1 }}
                        </template>
                    </veui-table-column>
                    <veui-table-column
                        field="num"
                        title="加购数量"
                        width="140"
                    />
                    <veui-table-column
                        field="tp_oid"
                        title="订单编号"
                        width="240"
                    />
                    <veui-table-column
                        field="unit_price"
                        title="加购单价"
                        width="140"
                    >
                        <template #default="{unit_price}">
                            {{ unit_price / 100 }}
                        </template>
                    </veui-table-column>
                    <veui-table-column
                        field="order_create_time"
                        title="订单生成时间"
                        width="140"
                    />
                </veui-table>
                <!-- 分页 -->
                <veui-pagination
                    v-if="tableData && tableData.length"
                    :page="pn"
                    :page-size="rn"
                    :total="count"
                    class="pagination"
                    @redirect="addCluePageChange"
                />
            </div>
            <!-- 客户信息 -->
            <div class="info">
                <div class="section-title">客户信息</div>
                <div class="columns">
                    <div class="column">
                        <div class="item">
                            <div class="title">客户姓名</div>
                            <div class="content">
                                {{ formData.name || "-" }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">执业资格证号</div>
                            <div class="content">
                                {{ formData.license || "-" }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">联系方式</div>
                            <div class="content">
                                {{ formData.phone || "-" }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">会员期限</div>
                            <div class="content">
                                {{ formData.duration || "-" }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">领域标签数量</div>
                            <div class="content">
                                {{ formData.domainFieldsNum || "-" }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">会员码绑码时间</div>
                            <div class="content">
                                {{ formData.bindTime | dateFilter }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">客保开始时间</div>
                            <div class="content">
                                {{ formData.ciStartTime | dateFilter }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">百度账号绑定手机号</div>
                            <div class="content">
                                {{ formData.passPhone || "-" }}
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="item">
                            <div class="title">客户身份</div>
                            <div class="content">
                                {{ formData.userType | userTypeFilter }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">城市</div>
                            <div class="content">
                                {{ formData.cityName | cityNameFilter }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">会员类型</div>
                            <div class="content">
                                {{ codeTypeMap[formData.codeType] || "-" }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">会员码归属地</div>
                            <div class="content">
                                {{ cityTypeMap[formData.cityLevel] || "-" }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">订单编号</div>
                            <div class="content">
                                {{ formData.tpOid || "-" }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">会员码失效时间</div>
                            <div class="content">
                                {{ formData.validityEnd | dateFilter }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">客保结束时间</div>
                            <div class="content">
                                {{ formData.ciEndTime | dateFilter }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">百度账号用户名</div>
                            <div class="content">
                                {{ formData.passName || "-" }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 会员订单历史 -->
            <div class="record">
                <div class="section-title">会员订单历史</div>
                <veui-table :data="tableData" role="columnheader">
                    <veui-table-column
                        field="codeType"
                        title="会员类型"
                        width="100"
                    >
                        <template #default="{codeType}">
                            {{ codeTypeMap[codeType] || "-" }}
                        </template>
                    </veui-table-column>
                    <veui-table-column
                        field="tpOid"
                        title="订单编号"
                        width="200"
                    />
                    <veui-table-column
                        field="bindTime"
                        title="会员绑码时间"
                        width="140"
                    >
                        <template #default="{bindTime}">
                            {{ bindTime | dateFilter }}
                        </template>
                    </veui-table-column>
                    <veui-table-column
                        field="validityStart"
                        title="会员生效时间"
                        width="140"
                    >
                        <template #default="{validityStart}">
                            {{ validityStart | dateFilter }}
                        </template>
                    </veui-table-column>
                    <veui-table-column
                        field="validityEnd"
                        title="会员失效时间"
                        width="140"
                    >
                        <template #default="{validityEnd}">
                            {{ validityEnd | dateFilter }}
                        </template>
                    </veui-table-column>
                </veui-table>
                <!-- 分页 -->
                <veui-pagination
                    v-if="tableData && tableData.length"
                    :page="pn"
                    :page-size="rn"
                    :total="count"
                    class="pagination"
                    @redirect="pageChange"
                />
            </div>
        </veui-drawer>
    </div>
</template>

<script>
/**
 * @file index.vue
 * @desc 客户详情
 * @author dingzhenyue
 */
import {Drawer, Column, Table, Pagination} from 'veui';
import {userTypeFilter} from '../util/filter';
import {dateFilter, cityNameFilter} from '@/utils/filter';
import {codeTypeMap, cityTypeMap} from '../util/config';

export default {
    name: 'customer-detail',
    props: {
        open: {
            type: Boolean,
            default: false
        },
        // 机构id
        fid: {
            type: [String, Number],
            default: ''
        },
        // 客户
        lawyer: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        'veui-drawer': Drawer,
        'veui-table': Table,
        'veui-table-column': Column,
        'veui-pagination': Pagination
    },
    data() {
        return {
            // 历史订单
            tableData: [],
            formData: {},
            pn: 1,
            rn: 10,
            // 总数
            count: 0,
            codeTypeMap,
            cityTypeMap,
            // 线索加购信息
            addClueFormData: {},
            // 线索加购记录
            addClueTableData: [],
            addCluePn: 1,
            addClueRn: 10,
            addClueTotal: 0
        };
    },
    filters: {
        userTypeFilter,
        dateFilter,
        cityNameFilter
    },
    mounted() {
        this.getRecordData();
        this.getDetail();
        this.getCustomerPrivilege();
        this.getAddClueRecord();
    },
    methods: {
        /**
         * 关闭当前抽屉
         */

        close() {
            this.$emit('closeDrawer');
        },

        /**
         * 翻页时更新数据
         *
         * @param {number} pn 第几页
         */

        pageChange(pn) {
            this.pn = pn;
            this.getRecordData();
        },

        /**
         * 获取客保记录数据
         */

        getRecordData() {
            let {fid, lawyer, pn, rn} = this;
            this.$http
                .get('/bp/crm/getorderlist', {
                    params: {
                        fid: fid,
                        license: lawyer.license || '',
                        pn,
                        rn
                    }
                })
                .then(res => {
                    const data = this.$normalizeResponseData(res);
                    if (!data) {
                        return;
                    }
                    this.tableData = data?.list || [];
                    this.count = data?.count;
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                });
        },

        /**
         * 获取详情
         */

        getDetail() {
            let {fid, lawyer} = this;
            this.$http
                .get('/bp/crm/getcustomer', {
                    params: {
                        fid: fid || '',
                        license: lawyer.license || ''
                    }
                })
                .then(res => {
                    if (!res.data) {
                        return;
                    }
                    this.formData = res.data || {};
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                });
        },
        // 获取线索消耗详情
        getCustomerPrivilege() {
            this.$http
                .get('/bp/firm/lawyer_clue_info', {
                    params: {qc_core_no: this.lawyer.qc_core_no}
                })
                .then(res => {
                    if (+res.code === 0 && res.data) {
                        const {add_clue_quota, consumed_add_clue_quota}
                            = res.data;
                        this.addClueFormData = {
                            add_clue_quota,
                            consumed_add_clue_quota
                        };
                    }
                });
        },
        // 获取线索加购记录
        getAddClueRecord() {
            let {addCluePn, addClueRn} = this;
            this.$http
                .get('/bp/api/clue/addtional_clue_order', {
                    params: {
                        qc_core_no: this.lawyer.qc_core_no,
                        pn: addCluePn,
                        rn: addClueRn
                    }
                })
                .then(res => {
                    if (+res.code === 0 && res.data && res.data.list) {
                        this.addClueTableData = res.data.list;
                        this.addClueTotal = res.data.total || 0;
                    }
                });
        },

        /**
         * 翻页时更新数据
         *
         * @param {number} pn 第几页
         */

        addCluePageChange(pn) {
            this.addCluePn = pn;
            this.getAddClueRecord();
        }
    }
};
</script>

<style lang='less' scoped>
@import "../../../assets/css/law-table.less";

.customer-detail {
    /deep/.veui-dialog-content-head {
        align-items: center;
        padding-bottom: 28px;
        position: absolute;
        right: 0;
        top: 0;

        .veui-dialog-content-head-title {
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #000;
            line-height: 16px;
        }
    }

    /deep/.veui-dialog-content {
        width: 990px;
    }

    /deep/.veui-dialog-content-body {
        margin-top: 45px;
    }

    .section-title {
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #000;
        line-height: 16px;
        margin-bottom: 36px;
    }

    .columns {
        display: flex;

        .column {
            display: flex;
            flex-direction: column;

            &:last-child {
                margin-left: 220px;
            }
        }

        .item {
            display: flex;
            font-size: 14px;
            color: #333;
            line-height: 14px;
            padding-bottom: 30px;

            .title {
                width: 100px;
            }

            .content {
                margin-left: 22px;
            }
        }
    }

    .record {
        margin-top: 10px;
        margin-bottom: 45px;

        .pagination {
            float: right;
            padding-top: 30px;
        }
    }
}

.foot {
    position: absolute;
    bottom: 24px;
    right: 30px;
}

/deep/.veui-button.veui-dialog-content-head-close {
    color: #000;
}
</style>

